import React, { useEffect, useState } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import NoDataComponent from "../../CoreComponents/NoDataComponent";
import {
  showMessage,
  getToken,
  ManageProducts,
  ManageRestaurant,
} from "../../Functionalities/Functions";
import { productListQuery, productMatchesWords, productRows } from "../../Functionalities/productSearch";
import axios from "axios";
import FilterComponent from "../../CoreComponents/FilterComponent";
import {
  is_superuser,
  url,
  token,
  protocol,
  is_back_office,
} from "../../Functionalities/Config";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import ToggleButton from "../../CoreComponents/ToggleButton";
import { validateOfferToggle } from "../Products/variantValidation";
import FilterModalComponent from "../../CoreComponents/FilterModalComponent";

function Body() {
  const [radio, setRadio] = useState({
    item: true,
    restaurant: false,
  });

  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [branches, setBranches] = useState([]);

  const [branchOffers, setBranchOffers] = useState({
    id: "",
    name: "",
    data: [],
  });
  const [nextbranchOffers, setbranchOffersNext] = useState("");
  const [prevbranchOffers, setbranchOffersPrev] = useState("");
  const [data, setData] = useState({ id: "", name: "", data: [] });
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");

  const [filter, setfilter] = useState({
    search_text: "",
    category_id: "",
    is_blocked: "",
    is_subscribable: "",
    is_out_of_stock: "",
    branch_id: "",
    type: "",
    is_recommended: "",
    is_featured: "",
    is_popular: "",
    is_trending: "",
    is_subscribable: "",
    location_id: "",
  });

  useEffect(() => {
    getData();
    getCategories();
    getBranches();
  }, []);

  const handlePrevbranchOffers = () => {
    // alert("prev");
    var config = {
      method: "get",
      url: prevbranchOffers,
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0

    axios(config)
      .then(function (response) {
        // void 0
        setBranchOffers({
          ...branchOffers,
          data: response.data.results,
        });
        setbranchOffersNext(response.data.next);
        setbranchOffersPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleNextbranchOffers = () => {
    //alert("next")
    var config = {
      method: "get",
      url: nextbranchOffers,
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        // void 0
        setBranchOffers({
          ...branchOffers,
          data: response.data.results,
        });
        setbranchOffersNext(response.data.next);
        setbranchOffersPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };
  // void 0

  const query = productListQuery({
    searchText: filter.search_text,
    franchiseLevel: is_back_office,
  });
  let params =
    query.params +
    "&for_dropdown=false&category_id=" +
    filter.category_id +
    "&is_blocked=" +
    filter.is_blocked +
    "&is_subscribable=" +
    filter.is_subscribable +
    "&is_out_of_stock=" +
    filter.is_out_of_stock +
    "&branch_id=" +
    filter.branch_id;

  const getData = () => {
    if (filter.type == "store") {
      params = params + "&is_grocery=true";
    }
    if (filter.type == "restaurant") {
      params = params + "&is_food=true";
    }

    if (filter.is_popular) {
      params = params + "&is_popular=true";
    } else if (filter.is_popular == "false") {
      params = params + "&is_popular=";
    } else {
      params = params;
    }

    if (filter.is_recommended) {
      params = params + "&is_recomended=true";
    } else if (filter.is_recommended == "false") {
      params = params + "&is_recomended=";
    } else {
      params = params;
    }

    if (filter.is_featured) {
      params = params + "&is_featured=true";
    } else if (filter.is_featured == "false") {
      params = params + "&is_featured=";
    } else {
      params = params;
    }

    if (filter.is_trending) {
      params = params + "&is_trending=true";
    } else if (filter.is_trending == "false") {
      params = params + "&is_trending=";
    } else {
      params = params;
    }

    if (filter.location_id) {
      params = params + "&location_id=" + filter.location_id;
    } else {
      params = params + "&keyword=all";
    }

    params = params + "&offer_items=true&date=" + new Date();

    // showMessage("Loading Products", "info", "Loading", "bottom", "bottom-left", 0);
    let result = ManageProducts("", "", "get", params);
    result
      .then((result) => {

        const rows = productRows(result.data);
        setData({
          ...data,
          data: query.filterInBrowser
            ? rows.filter((product) => productMatchesWords(product, query.words))
            : rows,
        });
        setLoading(false);
        setNext(query.filterInBrowser ? null : result.data.next);
        setPrev(query.filterInBrowser ? null : result.data.previous);
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
      });
  };

  const handlePrev = () => {
    // alert("prev");

    var config = {
      method: "get",
      url: prev.replace("http:", protocol.replace("//", "")),
      // url: prev + "/?" + params,

      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleNext = () => {
    // alert("next")
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace("//", "")),
      // url: next + "/?" + params,

      headers: {
        Authorization: getToken(),
      },
    };
    axios(config)
      .then(function (response) {
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const getCategories = () => {
    let params =
      "for_dropdown=true&page_wise=false&keyword=all&is_grocery=true";

    var config = {
      method: "get",
      url: url + "/items/category/?" + params,
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setCategories(response.data);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const getBranches = () => {
    let params = "for_dropdown=true&page_wise=false&is_store=true";
    // let params = "for_dropdown=true&page_wise=false";
    if (filter.location_id) {
      params = params + "&location_id=" + filter.location_id;
    }

    let result = ManageRestaurant("", "", "get", params);
    result
      .then((result) => {
        if (result) {
          setBranches(result.data);
        }
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-center",
          0
        );
        // void 0
      });
  };

  return (
    <div class="content-body">
      {!loading ? (
        <>
          {
            <div class="container-fluid">
              <FilterComponent
                handleNext={radio.item ? handleNext : handleNextbranchOffers}
                handlePrev={radio.item ? handlePrev : handlePrevbranchOffers}
                next={radio.item ? next : nextbranchOffers}
                prev={radio.item ? prev : prevbranchOffers}
                // addItemName={"Add Offers"}
                // addItemPath={"/addoffers"}
                // addItemPath={"/addOffers"}
                filterButtonName={"Filter"}
              />
              <FilterModalComponent
                heading={"Filter Products"}
                searchItemValue={filter.search_text}
                searchItemChange={(e) =>
                  setfilter({
                    ...filter,
                    search_text: e.target.value,
                  })
                }
                clearFilter={(e) => {
                  e.preventDefault();
                  window.location.reload();
                }}
                submitFilter={(e) => {
                  e.preventDefault();
                  getData();
                }}
              >
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="text-black font-w600">
                      Category <span className="required"></span>
                    </label>
                    <select
                      value={filter.category_id}
                      class="form-control form-control-lg  "
                      onChange={(e) =>
                        setfilter({
                          ...filter,
                          category_id: e.target.value,
                        })
                      }
                    >
                      <option value={""} id={""}>
                        All
                      </option>
                      {categories.map((item) => (
                        <option value={item.id} id={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {is_superuser && (
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="text-black font-w600">
                        Store <span className="required"></span>
                      </label>
                      <select
                        value={filter.branch_id}
                        class="form-control form-control-lg  "
                        onChange={(e) =>
                          setfilter({
                            ...filter,
                            branch_id: e.target.value,
                          })
                        }
                      >
                        <option value={""} id={""}>
                          All
                        </option>
                        {branches.length &&
                          branches.map((item) => (
                            <option value={item.id} id={item.id}>
                              {item.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                )}

                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="text-black font-w600">
                      Blocked <span className="required"></span>
                    </label>
                    <select
                      value={filter.is_blocked}
                      class="form-control form-control-lg  "
                      onChange={(e) =>
                        setfilter({
                          ...filter,
                          is_blocked: e.target.value,
                        })
                      }
                    >
                      <option value={""} id={""}>
                        All
                      </option>
                      <option value={"true"} id={"true"}>
                        Yes
                      </option>
                      <option value={"false"} id={"false"}>
                        No
                      </option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="text-black font-w600">
                      Stock <span className="required"></span>
                    </label>
                    <select
                      value={filter.is_out_of_stock}
                      class="form-control form-control-lg  "
                      onChange={(e) =>
                        setfilter({
                          ...filter,
                          is_out_of_stock: e.target.value,
                        })
                      }
                    >
                      <option value={""} id={""}>
                        All
                      </option>
                      <option value={"true"} id={"true"}>
                        Yes
                      </option>
                      <option value={"false"} id={"false"}>
                        No
                      </option>
                    </select>
                  </div>
                </div>
              </FilterModalComponent>

              <div className="row">
                <div className="col-xl-12 ">
                  <div className="card">
                    <div className="card-body p-0"></div>
                    {
                      <div className="table-responsive">
                        {radio.item &&
                          (data.data.length ? (
                            <table className="table table-responsive-md table-striped">
                              <thead style={{ border: " 1px solid #d4d4d4" }}>
                                <tr>
                                  <th>PRODUCT ID</th>
                                  {<th>PRODUCT</th>}
                                  <th>{"VARIANTS ACTIVE & INACTIVE"}</th>
                                  <th>{"OFFER PRICE & MRP"}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {data.data.length > 0 &&
                                  data.data.map((offer, dataIndex) => {
                                    return (
                                      <tr>
                                        <td>
                                          <h5 className="mb-0 fs--1">
                                            {" "}
                                            TCTOFRPDT{offer.id}
                                          </h5>
                                        </td>

                                        <td>
                                          <div className="d-flex align-items-center">
                                            <span className="w-space-no">
                                              <a
                                                target={"_blank"}
                                                href={`/productID/${offer.id}`} rel="noreferrer"
                                              >
                                                {offer.name}
                                              </a>

                                              <br />
                                            </span>
                                          </div>
                                        </td>

                                        <td>
                                          {offer.varients.map(
                                            (varient, index) => {
                                              return (
                                                <div
                                                  className="d-flex justify-content-between"
                                                  style={{
                                                    alignItems: "center",
                                                  }}
                                                  key={index}
                                                >
                                                  <p className="mb-0">
                                                    {varient.name}
                                                    {/* : Rs.
                                                                                                        {varient.retail_price} */}
                                                  </p>

                                                  <ToggleButton
                                                    inactiveLabel={""}
                                                    activeLabel={""}
                                                    thumbStyle={{
                                                      borderradius: 5,
                                                    }}
                                                    trackStyle={{
                                                      borderradius: 5,
                                                    }}
                                                    value={
                                                      varient.offer_enabled
                                                    }
                                                    onToggle={(val) => {
                                                      const turningOn =
                                                        !varient.offer_enabled;
                                                      const offerError =
                                                        validateOfferToggle(
                                                          varient,
                                                          turningOn
                                                        );
                                                      if (offerError) {
                                                        showMessage(
                                                          offerError,
                                                          "danger",
                                                          "Validation failed",
                                                          "top",
                                                          "top-right",
                                                          0
                                                        );
                                                        return;
                                                      }
                                                      var fdata =
                                                        new FormData();

                                                      fdata.append(
                                                        "keyword",
                                                        "offer_varient"
                                                      );
                                                      fdata.append(
                                                        "list_varients_info_id",
                                                        "[" + varient.id + "]"
                                                      );
                                                      fdata.append(
                                                        "status",
                                                        !varient.offer_enabled
                                                      );

                                                      var config = {
                                                        method: "patch",
                                                        url:
                                                          url +
                                                          "/items/itemvarients/",
                                                        headers: {
                                                          Authorization: token,
                                                        },
                                                        data: fdata,
                                                      };

                                                      axios(config)
                                                        .then(function (
                                                          response
                                                        ) {
                                                          if (
                                                            response.data
                                                              .Status == true
                                                          ) {
                                                            showMessage(
                                                              "Offer updated",
                                                              "success",
                                                              "Success!",
                                                              "top",
                                                              "top-right",
                                                              0
                                                            );

                                                            getData();
                                                          }
                                                        })
                                                        .catch(function (
                                                          error
                                                        ) {
                                                        });
                                                    }}
                                                  />
                                                </div>
                                              );
                                            }
                                          )}
                                        </td>

                                        <td>
                                          {offer.varients.map(
                                            (varient, index) => (
                                              <div className="d-flex justify-content-around">
                                                <p
                                                  className="mb-0"
                                                  style={{
                                                    fontWeight:
                                                      varient.offer_enabled &&
                                                      "bold",
                                                    textDecoration:
                                                      !varient.offer_enabled &&
                                                      "line-through",
                                                  }}
                                                >
                                                  ₹ {varient.offer_rate}
                                                </p>
                                                <p
                                                  className="mb-0"
                                                  style={{
                                                    fontWeight:
                                                      !varient.offer_enabled &&
                                                      "bold",
                                                    textDecoration:
                                                      varient.offer_enabled &&
                                                      "line-through",
                                                  }}
                                                >
                                                  ₹ {varient.rate}
                                                </p>
                                              </div>
                                            )
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          ) : (
                            <NoDataComponent data="Product Offer" />
                          ))}
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </>
      ) : (
        <LoadingComponent />
      )}
    </div>
  );
}

function ProductOffers() {
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header
          name={"Product Offers"}
          subHeading={"All offers under Foodoor"}
        />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default ProductOffers;
